import { useEffect, useState } from 'react';
import { onSelectChangeAdapter, SelectInput, TextInput, Toggle } from '@intellecteu/common-ui';
import { Labels } from 'app/constants';
import { DomainDto, useDomains } from 'data';
import { ui } from 'ui/styles';
import { Field } from '../ui';

import s from './styles.module.scss';

type ConnectToDomainProps = {
  custom?: boolean;
  domainName?: string;
  setFieldValue: (field: string, value: any, shouldValidate?: boolean | undefined) => void;
};

export const ConnectToDomain = ({ custom, domainName, setFieldValue }: ConnectToDomainProps) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { data, isFetching: isDomainsFetching } = useDomains({ enabled: isMenuOpen });

  const domainsList = data?.domains?.filter((el) => el.phase === DomainDto.phase.RUNNING);

  useEffect(() => {
    if (custom) {
      setFieldValue('domainName', '');
      setFieldValue('domainAlias', '');
      setFieldValue('publicPort', '');
    } else {
      const publicPort = domainsList?.find((el) => el.name === domainName)?.publicPort || '';
      setFieldValue('publicPort', publicPort);
      setFieldValue('domainAlias', domainName || '');
    }
  }, [domainName, custom]);

  return (
    <div className={ui.containerBody}>
      <Toggle.Small
        label={Labels.CUSTOM_DOMAIN}
        checked={!!custom}
        onChange={() => setFieldValue('custom', !custom)}
        horizontal
      />
      <div className={s.domain}>
        {custom ? (
          <Field component={TextInput} id="domainUrl" name="domainUrl" label={Labels.DOMAIN_URL} />
        ) : (
          <>
            <Field
              component={SelectInput}
              id="domainName"
              name="domainName"
              label={Labels.DOMAIN}
              options={domainsList}
              placeholder="Select domain..."
              loadingMessage={() => 'Loading domains...'}
              isClearable
              isLoading={isDomainsFetching}
              onFocus={() => setIsMenuOpen(!isMenuOpen)}
              onChangeAdapter={onSelectChangeAdapter}
              valueAdapter={(v) => domainsList?.find((el) => el.value === v) || ''}
            />

            <Field component={TextInput} id="publicPort" name="publicPort" label={Labels.PORT} disabled />
          </>
        )}
        <Field component={TextInput} id="domainAlias" name="domainAlias" label={Labels.DOMAIN_ALIAS} />
      </div>
    </div>
  );
};
